import React from "react";
import {WebService} from "../../module/WebService";
import {AppConfig} from "../../AppConfig";
import LoadingImage from "../LoadingImage";
import axios from "axios";
import {globalSession} from "../../module/Session";


class User extends React.Component {

    webService = new WebService();

    constructor(props) {
        super(props);
        this.state = {serviceState: -1};
        this.getData();
    }

    getData() {
        axios.get(AppConfig.server + AppConfig.service.admin.users, globalSession.getAuthToken())
            .then((res) => {
                const data = res.data;
                if (data.success) {
                    this.data = data["data"];
                    this.setState({
                        serviceState: 1
                    });
                } else
                    this.setState({
                        serviceState: 2
                    });
            })
            .catch(e => {
                this.setState({
                    serviceState: 3
                });
            })
    }

    render() {
        if (this.state.serviceState === 1) {
            return (
                <div>
                    <h3><strong>Operatörler</strong></h3>
                    <hr/>
                    <table className="table">
                        <thead>
                        <tr>
                            <th scope="col" style={{width: "100px"}}>Sicil No.</th>
                            <th scope="col">Ad</th>
                            <th scope="col">Soyad</th>
                            <th scope="col">Telefon</th>
                            <th scope="col">E-mail</th>
                            <th scope="col">Rol</th>
                            <th scope="col">Durum</th>
                            <th scope="col" style={{width: "300px"}}>İşlemler</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderUserRow()}
                        </tbody>
                    </table>
                </div>
            )
        } else if (this.state.serviceState === -1) {
            return (
                <LoadingImage/>
            )
        } else {
            return (
                <span>Tanımlı kullanıcı yoktur</span>
            )
        }
    }

    renderUserRow() {
        const data = this.data;
        const userData = [];
        for (let i = 0; i < data.length; i++) {
            const currentData = data[i];

            userData.push(<tr>
                <th>{currentData["registryNo"]}</th>
                <td>{currentData["name"]}</td>
                <td>{currentData["surname"]}</td>
                <td>{this.contact(currentData["contact"], "phone")}</td>
                <td>{this.contact(currentData["contact"], "mail")}</td>
                <td>{this.roles(currentData["roles"])}</td>
                <td>{currentData["active"] ? "Aktif" : "Pasif"}</td>
                <td>
                    <a href={AppConfig.pages.admin.department + "?userId=" + currentData["id"]}> Grup Ata </a>
                    <a href={AppConfig.pages.admin.call + "?userId=" + currentData["id"]}
                       style={{marginLeft: "10px"}}> Çağrı Ata </a>
                    <a href={AppConfig.pages.admin.editOperator + "?userId=" + currentData["id"]}
                       style={{marginLeft: "10px"}}> Düzenle </a>
                </td>
            </tr>)
        }

        return userData;
    }

    contact(value, key) {
        if (value != null && value[key]!=null)
            return value[key];
        return "---";
    }

    roles(value) {
        let v = "";
        value.map((item) => v += item.name + ", ")
        return v.substring(0, v.length - 2);
    }

}

export default User;